import React from 'react';
import { CheckIcon, HelpCircleIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { FrameworkStrip } from '../FrameworkStrip';
import { dealingWith, needToKnow } from '../../data/landing';
export function Signs() {
  return <section className="bg-white" data-id="element-301" data-mp="3cyw0wpdxsd3l">
      <div className="mx-auto max-w-5xl px-5 py-14 md:py-20" data-id="element-302" data-mp="3czxd4x6ov5mw">
        <SectionHeading title={<>If you're dealing with…</>} data-id="element-303" data-mp="3hyieizxofvcx" />

        <ul className="mx-auto mt-8 grid max-w-3xl gap-3 sm:grid-cols-2" data-id="element-304" data-mp="3lzaoxwiac6as">
          {dealingWith.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-cream px-4 py-3.5" data-id="element-305" data-mp="3qqaicrs7468j">
              <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-coral text-white" data-id="element-306" data-mp="3vou8739wu266">
                <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-307" data-mp="4jlskzjgebnd" />
              </span>
              <span className="text-[17px] font-bold leading-snug text-navy" data-id="element-308" data-mp="9h46738f1f1p">{item}</span>
            </li>)}
        </ul>

        <p className="mt-8 text-center font-display text-2xl font-bold text-teal-dark sm:text-3xl" data-id="element-309" data-mp="18m8zrrnonlnw">
          …I created this system for you.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg leading-relaxed text-muted" data-id="element-310" data-mp="ylyq2h0uwwdh">
          Because I know that when a meltdown starts, the last thing you need is{' '}
          <strong className="text-navy" data-id="element-311" data-mp="1rb5w012n4o8r">another 20 articles</strong> telling you what you could try.
        </p>

        <div className="mx-auto mt-12 max-w-3xl rounded-3xl bg-navy p-6 sm:p-10" data-id="element-312" data-mp="1mccfs0vyyj4w">
          <h3 className="text-center font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-313" data-mp="1hlcnj8xsop8q">You need to know:</h3>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-314" data-mp="1dk0wr036pxyy">
            {needToKnow.map(q => <li key={q} className="flex items-center gap-3 rounded-2xl bg-white/10 px-4 py-4" data-id="element-315" data-mp="2a1f1bjtq4w4o">
                <HelpCircleIcon className="h-6 w-6 shrink-0 text-sun" aria-hidden="true" data-id="element-316" data-mp="25b6xniqqbzpa" />
                <span className="text-lg font-bold leading-snug text-white" data-id="element-317" data-mp="3depny0syhnh">{q}</span>
              </li>)}
          </ul>
        </div>

        <div className="mt-12 text-center" data-id="element-318" data-mp="8b6f8ldz5roi">
          <p className="text-lg font-bold text-muted" data-id="element-319" data-mp="3pszcrsjbm78i">That's why I created:</p>
          <p className="mt-2 font-display text-[22px] font-bold leading-tight text-navy sm:text-3xl" data-id="element-320" data-mp="3pqwp3f5n4q6y">
            Pause → Observe → Reduce → Regulate → Recover
          </p>
          <div className="mt-6" data-id="element-321" data-mp="3gri0ymcy4rpm">
            <FrameworkStrip data-id="element-322" data-mp="3gunpo0hnxrkt" />
          </div>
          <p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-323" data-mp="3lrns81fb0c76">
            My Calm Response 5™ system gives you a simple framework you can actually remember and use. Inside, I'll give you{' '}
            <strong className="text-navy" data-id="element-324" data-mp="3btzown3mtwde">6 practical volumes, 5 exclusive bonuses, SOS response cards, checklists, visual routines</strong>{' '}
            and a personal planning system.
          </p>
        </div>

        <div className="mt-10" data-id="element-325" data-mp="1a121x7wjdy0d">
          <CTAButton label="I want a plan I can actually remember" data-id="element-326" data-mp="2ujvrpl28eq0s" />
        </div>
      </div>
    </section>;
}